import Work1 from "../../assets/work1.jpg";
import Work2 from "../../assets/work2.jpg";
import Work3 from "../../assets/work3.jpg";
import Work4 from "../../assets/work4.jpg";
import Work5 from "../../assets/work5.jpg";

export const projectsData = [
  {
    id: 1,
    image: Work5,
    title: "Full-Stack E-commerce Website",
    category: "web",
    link: "https://photoland-api.vercel.app/",
  },
  {
    id: 2,
    image: Work1,
    title: "Social Media Website",
    category: "web",
    link: "https://network-frontend.onrender.com/",
  },
  {
    id: 3,
    image: Work2,
    title: "Client Management Dashboard",
    category: "web",
    link: "https://hemanth307.github.io/ADMIN-DASHBOARD/",
  },
  {
    id: 4,
    image: Work3,
    title: "Food Ordering UI",
    category: "web",
    link: "https://hemanth307.github.io/Food-Website/",
  },
  // {
  //   id: 5,
  //   image: Work4,
  //   title: "Data Visualization",
  //   category: "app",
  //   link: "https://drive.google.com/drive/folders/1Ue8N_yMWO2H1ZhD8KaieDEsesj5cQFra?usp=share_link",
  // },
];

export const projectsNav = [
  {
    name: "all",
  },
];
